import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NavigationLink } from 'app/shared/models/navigation-link.model';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-case-form-section-container',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslateModule],
  templateUrl: './case-form-section-container.component.html',
  styleUrl: './case-form-section-container.component.scss'
})

export class CaseFormSectionContainerComponent {
  @Input() iconClass!: string;
  @Input() rightIconClass!: string;
  @Input() navigationLink!: NavigationLink;
  @Input() title!: string;
  @Input() buttonLabel!: string;
  @Input() showButton!: boolean ;
  @Input() buttonIconClass!: string ;
  @Input() iconDisabled: boolean = false;

  @Output() onButtonClick = new EventEmitter<void>();
  @Output() onClickRightIcon = new EventEmitter<boolean>();
  toggle!: boolean;

  onClickAction() {
    if(this.iconDisabled) {
      return;
    }
    this.toggle = !this.toggle;
    this.onClickRightIcon.emit(this.toggle);
  }

  handleButtonClick() {
    this.onButtonClick.emit();
  }
}
